<app-properties-anne-fin (IsChangeAnnexeFINEm)="IsChangeAnnexeFIN($event)" [annexeUpdate]="annexeUpdateAux"></app-properties-anne-fin>

<!---===================== MODAL FOR PROPERTIES FIN =====================--->
<section class="Modal-Global ModalPropertiesFIN" id="ModalPropertiesFIN">
  <div class="wrapper">
    <div class="Pro-popupFIN1 popup">
      <div class="Pro-insideFIN1 popup-inside">
        <div class="Pro-backgroundsFIN1 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <form [formGroup]="FormFINProperties" (ngSubmit)="SaveEditProperties()">
        <div class="Pro-contentFIN1 content">
          <button (click)="ToggleModalProperties(false)" type="button" class="Btn-Close"><i
              class="fa-solid fa-xmark"></i></button>
          <div class="Content-Top">
            <h2>Propiedades <span *ngIf="!CanEditProperties" style="font-size: 0.6em; color: #fc6161; vertical-align: middle;">(Solo Lectura)</span></h2>
            <h4>{{ !CanEditProperties ? 'Visualizando' : 'Modifica' }} las propiedades de {{FILE_FIN_Properties.Name}}</h4>
          </div>

          <div class="Content-body Form-Properties">

            <div class="Content-grid-2">
              <div class="Text-icon">
                Nombre del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-qrcode"></i><input id="IdInputFilePropertiesFIN" type="text"
                  formControlName="NameFIN" placeholder="Nombre del Proceso…">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Código del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-qrcode"></i><input id="IdinputCodePropertiesFIN" type="text"
                  formControlName="Code" placeholder="Código…">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                Objetivo del Proceso
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-regular fa-message"></i><input id="IdinputPurpPropertiesFIN" type="text"
                  formControlName="Purpose" placeholder="Objetivo del Proceso (Purpose)…">
              </div>
            </div>

            <div class="Content-grid-2">
              <div class="Text-icon">
                NO. Revisión
              </div>
              <div class="Container-input Input-Text-Form">
                <i class="fa-solid fa-ellipsis"></i><input id="IdinputNoRePropertiesFIN" type="text" formControlName="Revision_No"
                  placeholder="Numero de revisión…">
              </div>
            </div>

            <!-- Formulario asociado -->
            <div *ngIf="HasFormSubmission" class="form-submission-section" style="order: -1;">
              <div class="form-sub-header">
                <div class="form-sub-info">
                  <i class="fa-solid fa-file-lines"></i>
                  <div>
                    <span class="form-sub-name">{{ FormTemplate?.Name || 'Formulario asociado' }}</span>
                    <span *ngIf="FormTemplate" class="form-sub-version">V{{ FormTemplate.Version }}</span>
                  </div>
                </div>
                <button type="button" class="form-sub-edit" (click)="EditFormSubmission()" *ngIf="FormTemplate && CanEditProperties">
                  <i class="fa-solid fa-pen"></i> Editar formulario
                </button>
              </div>
              <div class="form-sub-preview">
                <ng-container *ngFor="let val of FormSubmission?.Values">
                  <!-- Skip signature and table in list view -->
                  <div *ngIf="val.Field_Type !== 'signature' && val.Field_Type !== 'table' && val.Field_Type !== 'section'" class="form-sub-row">
                    <span class="form-sub-label">{{ val.Label || 'Campo' }}</span>
                    <span class="form-sub-value" *ngIf="val.Field_Type === 'boolean'">{{ val.Value === 'true' ? 'Si' : 'No' }}</span>
                    <span class="form-sub-value" *ngIf="val.Field_Type === 'date'">{{ FormatDateValue(val.Value) }}</span>
                    <span class="form-sub-value" *ngIf="val.Field_Type !== 'boolean' && val.Field_Type !== 'date'">{{ val.Value || '—' }}</span>
                  </div>
                  <!-- Signature as image -->
                  <div *ngIf="val.Field_Type === 'signature' && val.Value" class="form-sub-row form-sub-row-sig">
                    <span class="form-sub-label">{{ val.Label || 'Firma' }}</span>
                    <img [src]="val.Value" class="form-sub-sig-img" alt="Firma" />
                  </div>
                  <!-- Table as count -->
                  <div *ngIf="val.Field_Type === 'table'" class="form-sub-row">
                    <span class="form-sub-label">{{ val.Label || 'Tabla' }}</span>
                    <span class="form-sub-value">{{ GetTableRowCount(val.Value) }} filas</span>
                  </div>
                </ng-container>
              </div>
            </div>

            <div class="Content-grid-2" *ngIf="ShowReviewerBlock('APPR1') && (IsReviewerAssigned(1) || FILE_FIN_Properties.Status === 0)" [style.order]="GetReviewerOrder('APPR1')">
              <div class="Text-icon">
                {{GetReviewerHeaderName('APPR1', 'Mgr. Process Owner')}}
              </div>
              <ng-container
                *ngIf="CheckEditTask(FILE_FIN_Properties.TaskApprover1,FILE_FIN_Properties.Status);else NotModifiedApprover1">
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete">
                    <i class="fa-regular fa-user"></i>
                    <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="Permission_FMF.Users_Groups_For_Role.G_Approvers_1.Users"
                      id="IdInputAuA1PropertiesFIN" [initialValue]="" placeholder="Buscar usuario Mgr. Process Owner"
                      searchKeyword="Name"  notFoundText="Usuario no encontrado"
                      [itemTemplate]="itemTemplateReviewers" [notFoundTemplate]="notFoundReviewers"
                      formControlName="Approver1">
                    </ng-autocomplete>

                    <ng-template #itemTemplateReviewers let-item>
                      <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundReviewers let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover1)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover1.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>

              </ng-container>
              <ng-template #NotModifiedApprover1>
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete  Is-Disabled">
                    <i class="fa-regular fa-user"></i>
                    <div class="NameReviwer">{{Get_Name_Approver(FILE_FIN_Properties.Approver1_Name)}}</div>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover1)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover1.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>

            </div>

            <div class="Content-grid-2" *ngIf="ShowReviewerBlock('APPR2') && (IsReviewerAssigned(2) || FILE_FIN_Properties.Status === 0)" [style.order]="GetReviewerOrder('APPR2')">
              <div class="Text-icon">
                {{GetReviewerHeaderName('APPR2', 'RM & ICS Specialist')}}
              </div>
              <ng-container
                *ngIf="CheckEditTask(FILE_FIN_Properties.TaskApprover2,FILE_FIN_Properties.Status);else NotModifiedApprover2">
                <div class="Container-input Propeties-Container">
                  <div class="Container-input Input-Autocomplete">
                    <i class="fa-regular fa-user"></i>
                    <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="Permission_FMF.Users_Groups_For_Role.G_Approvers_2.Users"
                      id="IdInputAuA2PropertiesFIN" [initialValue]="" placeholder="Buscar usuario RM & ICS Specialist"
                      searchKeyword="Name"  notFoundText="Usuario no encontrado"
                      [itemTemplate]="itemTemplateReviewers" [notFoundTemplate]="notFoundReviewers"
                      formControlName="Approver2">
                    </ng-autocomplete>

                    <ng-template #itemTemplateReviewers let-item>
                      <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundReviewers let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover2)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover2.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #NotModifiedApprover2>
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete  Is-Disabled">
                    <i class="fa-regular fa-user"></i>
                    <div class="NameReviwer">{{Get_Name_Approver(FILE_FIN_Properties.Approver2_Name)}}</div>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover2)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover2.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>

            </div>

            <div class="Content-grid-2" *ngIf="ShowReviewerBlock('APPR3') && (IsReviewerAssigned(3) || FILE_FIN_Properties.Status === 0)" [style.order]="GetReviewerOrder('APPR3')">
              <div class="Text-icon">
                {{GetReviewerHeaderName('APPR3', 'RM & ICS Sr. Mgr.')}}
              </div>
              <ng-container
                *ngIf="CheckEditTask(FILE_FIN_Properties.TaskApprover3,FILE_FIN_Properties.Status);else NotModifiedApprover3">
                <div class="Container-input Propeties-Container">
                  <div class="Container-input Input-Autocomplete">
                    <i class="fa-regular fa-user"></i>
                    <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="Permission_FMF.Users_Groups_For_Role.G_Approvers_3.Users"
                      id="IdInputAuA3PropertiesFIN" [initialValue]="" placeholder="Buscar usuario RM & ICS Sr. Mgr."
                      searchKeyword="Name"  notFoundText="Usuario no encontrado"
                      [itemTemplate]="itemTemplateReviewers" [notFoundTemplate]="notFoundReviewers"
                      formControlName="Approver3">
                    </ng-autocomplete>

                    <ng-template #itemTemplateReviewers let-item>
                      <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundReviewers let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover3)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover3.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #NotModifiedApprover3>
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete  Is-Disabled">
                    <i class="fa-regular fa-user"></i>
                    <div class="NameReviwer">{{Get_Name_Approver(FILE_FIN_Properties.Approver3_Name)}}</div>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover3)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover3.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>

            </div>


            <div class="Content-grid-2" *ngIf="ShowReviewerBlock('APPR4') && (IsReviewerAssigned(4) || FILE_FIN_Properties.Status === 0)" [style.order]="GetReviewerOrder('APPR4')">
              <div class="Text-icon">
                {{GetReviewerHeaderName('APPR4', 'Director or CFO')}}
              </div>
              <ng-container
                *ngIf="CheckEditTask(FILE_FIN_Properties.TaskApprover4,FILE_FIN_Properties.Status);else NotModifiedApprover4">
                <div class="Container-input Propeties-Container">
                  <div class="Container-input Input-Autocomplete">
                    <i class="fa-regular fa-user"></i>
                    <ng-autocomplete class="ng-autocomplete" #ngAutoCompleteReviewers [data]="Permission_FMF.Users_Groups_For_Role.G_Approvers_4.Users"
                      id="IdInputAuA4PropertiesFIN" [initialValue]=""
                      placeholder="Buscar usuario Finance Director or CFO" searchKeyword="Name"
                       notFoundText="Usuario no encontrado"
                      [itemTemplate]="itemTemplateReviewers" [notFoundTemplate]="notFoundReviewers"
                      formControlName="Approver4">
                    </ng-autocomplete>

                    <ng-template #itemTemplateReviewers let-item>
                      <a [innerHTML]="item.Name"></a>
                    </ng-template>

                    <ng-template #notFoundReviewers let-notFound>
                      <div [innerHTML]="notFound"></div>
                    </ng-template>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover4)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover4.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-container>
              <ng-template #NotModifiedApprover4>
                <div class="Container-input Propeties-Container">
                  <div class="Input-Autocomplete  Is-Disabled">
                    <i class="fa-regular fa-user"></i>
                    <div class="NameReviwer">{{Get_Name_Approver(FILE_FIN_Properties.Approver4_Name)}}</div>
                  </div>
                  <div class="Status-Task">
                    <div class="Icon-Status Status{{Check_Status_Task_Icon(FILE_FIN_Properties.TaskApprover4)}}">
                      <ng-container *ngFor="let Icon_Task of Icons_Status">
                        <div *ngIf="Icon_Task.Status === FILE_FIN_Properties.TaskApprover4.Status">
                          <i class="fa-solid {{Icon_Task.Icon}}"></i>
                        </div>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </ng-template>
            </div>

            <div class="Content-grid-2" *ngIf="CanEditProperties">
              <div class="Text-icon">
                Anexos
              </div>
              <div class="Container-input InputFile">
                <div class="IputFileleft">
                  <i class="fa-solid fa-plus"></i>
                  <div class="Text-input">Cargar Archivos</div><input (change)="Add_Document_Annexe_Properties($event)"
                    #PropertiesFileAnnexe type="file" name="">
                </div>
              </div>
            </div>

            <div class="Content-grid-2 Container-Annexes">
              <div class="Not-Annexes">
                <div class="Img-Not ">
                  <img src="./assets/Global/Ilustrations/Not-Annexes.png" alt="">
                </div>
              </div>
              <div class="Container-Card-Annexes">

                <div *ngIf="FileAuxPropeties_Anne.length === 0">No hay anexos cargados aún.</div>

                <ng-container *ngFor="let Annexe of FileAuxPropeties_Anne">

                  <div *ngIf="Annexe.Status!==5" class="Card-Annexes">

                    <div class="Container-File">
                      <ng-container *ngFor="let icon of Icons_Image">
                        <div *ngIf="Annexe.Extension.toUpperCase()==icon.Extension.toUpperCase()">
                          <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                        </div>
                      </ng-container>
                      <div class="Name-Annexe">
                        {{CutNameFile(Annexe.FileName,35)}}
                      </div>
                    </div>

                    <div class="Container-Buttons-Annexe">
                      <button type="button" *ngIf="Annexe.UpdateAnnexe.FileName!==''" class="button-square">
                        <i class="fa-regular fa-paste"></i>
                      </button>
                      <button type="button" *ngIf="Annexe.ID!==0 && CanEditProperties" (click)="Annexe_Properties(Annexe)"
                        class="Update-Annexe button-square">
                        <i class="fa-solid fa-upload"></i>
                      </button>
                      <button *ngIf="CanEditProperties" (click)="ToggleModalPropertiesAnnexeFIN(true)" (click)="setAnnexeUpdate(Annexe)" type="button" class="button-square">
                        <i class="fa-solid fa-pen-to-square"></i>
                      </button>
                      <button *ngIf="CanEditProperties && (UserService.UserRoleGeneralIn([RolesGeneral.AdministratorFIN]) || Annexe.ID===0)" type="button" (click)="Delete_Annexe_Properties_Modal(Annexe.FileName)"
                        class="Delete-Annexe button-square">
                        <i class="fa-solid fa-xmark"></i>
                      </button>
                    </div>
                  </div>




                </ng-container>

              </div>

            </div>

            <!-- Mensaje cuando no hay revisores -->
            <div class="Not-Reviewers" *ngIf="!HasReviewers()">
              <i class="fa-solid fa-user-slash"></i>
              <span>No se asignaron revisores a este proceso.</span>
            </div>

            <!-- Resumen al final -->
            <div *ngIf="FILE_FIN_Properties.Summary" class="Not-Reviewers" style="flex-direction: column; align-items: flex-start;">
              <div style="color: #333; font-weight: bold; margin-bottom: 10px; display: flex; align-items: center;">
                <i class="fa-solid fa-align-left" style="color: #20a8e1; margin-right: 8px; font-size: 1.1em;"></i> 
                Resumen
              </div>
              <div style="font-size: 0.95em; line-height: 1.6; color: #444; text-align: justify; width: 100%;">
                {{ FILE_FIN_Properties.Summary }}
              </div>
            </div>

          </div>

          <div class="Container-Progress" id="Content-Progress-Update">
            <div class="ProgressBar" id="Progress-Bar-Update"></div>
          </div>
          <div class="Content-Bottom Content-Bottom-Properties">
            <button type="submit" class="Btn-LSave-Form Btn-Save-Modal" *ngIf="CanEditProperties">
              <i class="icon-send material-icons" id="Send-Icon-Update">send</i>
              <i class="icon-check material-icons" id="Check-Icon-Update">check</i>
              <span class="Btn-Save-Modal-text" id="Text-Btn-Update">Guardar Cambios</span>
            </button>
            <button type="button" (click)="DownloadFile()" class="Btn-LSave-Form Btn-Save-Modal"
              id="Btn-Download-Properties" title="Descargar documento">
              <i class="icon-send material-icons">cloud_download</i>
              <span class="Btn-Save-Modal-text">Descargar</span>
            </button>
            <button type="button" (click)="ToggleModalProperties(false)" class="Btn-LCancel-Form Btn-Close-Modal">
              <span>Cerrar</span>
            </button>

          </div>

        </div>
      </form>
    </div>
  </div>
</section>

<!---===================== MODAL FOR UPDATE ANNEXE =====================--->
<section class="Modal-Global Modal_Properties" id="Modal_Properties_Annexe">

  <div class="wrapper">
    <div class="Popup-Add-annexe popup">
      <div class="Inside-Add-annexe popup-inside">
        <div class="Background-Add-annexe backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>

      <div class="Content-Add-annexe content">
        <button (click)="Toogle_Modal_Properties_Annexe(false)" type="button" id="Btn-Close-Update-Top"
          class="Btn-Close"><i class="fa-solid fa-xmark"></i></button>
        <div class="Content-Top">
          <h2>Actualizar Anexo</h2>
          <h4>Seleccione un archivo para actualizar</h4>
        </div>

        <div class="Content-body">

          <div class="Container-input-annexe">

            <div class="IputFileleft">
              <i class="fa-solid fa-plus"></i>
              <div class="Text-input">Cargar Archivo</div><input #UpdFile_Properties_Annexe
                (change)="Add_Annexe_Properties($event)" type="file" name="">
            </div>

            <div *ngIf="FileAuxUpdFIN_Annexe_Properties.UpdateAnnexe.FileName!==''"
              class="Container-Card-Annexes Card-Update-Annexe">

              <div class="Card-Annexes">

                <div class="Container-File">
                  <ng-container *ngFor="let icon of Icons_Image">
                    <div *ngIf="FileAuxUpdFIN_Annexe_Properties.UpdateAnnexe.Extension.toUpperCase() === icon.Extension.toUpperCase()">
                      <img src="./assets/Global/icons/{{icon.Url_Image}}" alt="" srcset="">
                    </div>
                  </ng-container>
                  <div class="Name-Annexe">
                    {{CutNameFile(FileAuxUpdFIN_Annexe_Properties.UpdateAnnexe.FileName,35)}}
                  </div>
                </div>

                <div class="Container-Buttons-Annexe">
                  <button (click)="Delete_Properties_Annexe()" type="button" class="Delete-Annexe button-square">
                    <i class="fa-solid fa-xmark"></i>
                  </button>
                </div>

              </div>

            </div>

          </div>
        </div>

        <div class="Content-Bottom Modal-Annexe">
          <button (click)="Toogle_Modal_Properties_Annexe(false)" type="button" class="Btn-OK">
            <span>OK</span>
          </button>
        </div>

      </div>

    </div>

  </div>

</section>
